import * as angular from 'angular';
import template from './deleteGobWeight.tpl.html';


export function openDeleteGobWeight($modal: mm.foundation.modal): angular.IPromise<string> {
  return $modal.open({
    template: template,
    controller: 'DeleteGobWeightCtrl as vm',
  }).result;
}

export default angular.module('aps.controller.deleteGobWeight', [])
  .controller('DeleteGobWeightCtrl', (
    $modalInstance: mm.foundation.modalInstance,
  ) => {
    let vm = {
      comment: null,
      form: <angular.IFormController>null,
      cancel: () => $modalInstance.close(),
      submit: () => {
        if (vm.form.$invalid) {
          return;
        }

        $modalInstance.close(vm.comment);
      }
    };

    return vm;
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/deleteGobWeight.controller.ts